import { Avatar, Button, Card, Row, Skeleton } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { contextApp } from "../../firebase/context";
import { getColection } from "../../firebase/fireStore";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import Cargando from "../../components/Cargando";

const { Meta } = Card;
const HistoryAppoitment = () => {
  const { usuario } = useContext(contextApp);
  const [loading, setLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const [reminders, setreminders] = useState([]);
  const getProfesionales = async () => {
    setIsLogin(true);
    setLoading(true);
    const response = (await getColection("Appointment")) || [];
    const getdata = response.filter(
      (item) => item.data.emailPaciente === usuario.email
    );
    setreminders(getdata);
    setIsLogin(false);
    setLoading(false);
    //setTopic(getdata.data.topic);
  };
  useEffect(() => {
    getProfesionales();
  }, [usuario]);
  return (
    <div>
      {loading && <Cargando />}
      <Row gutter={16}>
        {(reminders || []).length > 0 ? (
          (reminders || []).map((reminder, index) => (
            <Card
              key={index}
              style={{
                marginTop: 16,
                marginLeft: 16,
              }}
            >
              {" "}
              {isLogin === true ? (
                <Skeleton avatar active />
              ) : (
                <>
                  <Meta
                    avatar={
                      <Avatar
                        style={{ width: 20, height: 20 }}
                        src={
                          reminder.data.photoPsicologo
                            ? reminder.data.photoPsicologo
                            : "https://firebasestorage.googleapis.com/v0/b/kameliadev-a0de5.appspot.com/o/photoURL%2FDefault%2Fprofile_icon.png?alt=media&token=df0e7294-8dee-40cd-ab9e-4fd18c723df7"
                        }
                      />
                    }
                    title={`Cita con `}
                    description={reminder.data.namePsicologo}
                  />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Estado: <div> {reminder.data.status}</div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Fecha:{" "}
                    <div>
                      {" "}
                      {format(new Date(reminder.data.date), "PPP", {
                        locale: es,
                      })}
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    Hora: <div> {reminder.data.time}</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    Suscripción:{" "}
                    <div>
                      {reminder.data.paid ? (
                        <div style={{ color: "#688C07" }}>Activa</div>
                      ) : (
                        <div style={{ color: "#FF141F" }}>Inactiva</div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "column",
                    }}
                  ></div>
                </>
              )}
            </Card>
          ))
        ) : (
          <div>"¡Oh vaya! parece que aun no tienes citas Aún."</div>
        )}
      </Row>
    </div>
  );
};

export default HistoryAppoitment;
